"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _InternalLink = _interopRequireDefault(require("../../../atoms/InternalLink"));

var _LinkContent = _interopRequireDefault(require("./LinkContent"));

var _OutboundLink = _interopRequireDefault(require("../../../atoms/OutboundLink"));

var _default = function _default(_ref) {
  var linksAs = _ref.linksAs,
      item = _ref.item,
      index = _ref.index,
      internalLinkComponent = _ref.internalLinkComponent;
  var pageTitle = item.pageTitle,
      slug = item.slug,
      internal = item.internal,
      className = item.className;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, {
    key: index
  }, internal ? /*#__PURE__*/_react["default"].createElement(_InternalLink["default"], {
    gatsbyLink: true,
    to: slug,
    label: pageTitle,
    as: internalLinkComponent,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_LinkContent["default"], {
    linksAs: linksAs,
    item: item
  })) : /*#__PURE__*/_react["default"].createElement(_OutboundLink["default"], {
    label: pageTitle,
    to: slug,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_LinkContent["default"], {
    linksAs: linksAs,
    item: item
  })));
};

exports["default"] = _default;